import React from "react";
import { Phone } from "lucide-react";

const TopBanner = () => {
  return (
    <div className="bg-blue-600 text-white py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center text-sm">
          <Phone className="h-4 w-4 mr-2" />
          <span className="font-medium">Call Now for Fast Cash Offers:</span>
          <a 
            href="tel:1-888-334-3524" 
            className="ml-2 font-bold text-yellow-300 hover:text-yellow-200 transition-colors"
          >
            1-888-334-3524
          </a>
          <span className="ml-4 text-blue-200">| 8 AM - 5 PM CDT, 7 Days a Week</span>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;